import request from '@/utils/request'

// 登录
export function login(data) {
  return request({ url: '/ftx/auth/login', method: 'post', data })
}

// 注册步骤1 - 邮箱验证
export function registerStep1(data) {
  return request({ url: '/ftx/auth/register/step1', method: 'post', data })
}

// 注册步骤2 - 设置登录密码
export function registerStep2(data) {
  return request({ url: '/ftx/auth/register/step2', method: 'post', data })
}

// 注册步骤3 - 设置交易密码
export function registerStep3(data) {
  return request({ url: '/ftx/auth/register/step3', method: 'post', data })
}

// 注册步骤4 - 邀请码+完成注册
export function registerStep4(data) {
  return request({ url: '/ftx/auth/register/step4', method: 'post', data })
}

// 获取图形验证码
export function getCaptcha() {
  return request({ url: '/ftx/auth/captcha', method: 'get' })
}

// 发送邮箱验证码
export function sendEmailCode(data) {
  return request({ url: '/ftx/auth/send-code', method: 'post', data })
}

// 获取当前用户信息
export function getProfile(options = {}) {
  return request({ url: '/ftx/auth/profile', method: 'get', ...options })
}

// 退出登录
export function logout() {
  return request({ url: '/ftx/auth/logout', method: 'post' })
}

// 重置密码
export function resetPassword(data) {
  return request({ url: '/ftx/auth/reset-password', method: 'post', data })
}

// ========== 记住账号（Redis 持久化） ==========

// 获取记住的账号
export function getRememberedAccount() {
  return request({ url: '/ftx/auth/remembered-account', method: 'get', skipLogout: true })
}

// 保存记住的账号
export function saveRememberedAccount(data) {
  return request({ url: '/ftx/auth/remembered-account', method: 'post', data })
}

// 删除记住的账号
export function deleteRememberedAccount() {
  return request({ url: '/ftx/auth/remembered-account', method: 'delete' })
}
